import Inputs from "./Screen/Inputs";
import Buttons from "./Screen/Buttons";
import Headline from "./Screen/Headline";
import BackButton from "./Screen/BackButton";

import { defaultItems } from "../Utils";

export default function Screen({
  id,
  question,
  visible,
  showNext,
  showPrev,
  current,
  onChangeInput,
  onChangeButton,
  form,
}) {
  return (
    <>
      {visible && (
        <div className="screen" id={id}>
          <BackButton visible={current !== 0} onClick={showPrev} />

          <Headline>{question.title}</Headline>

          {question.scope === "input" && (
            <Inputs
              items={question.items}
              onComplete={showNext}
              onChange={onChangeInput}
              screenIndex={id}
              form={form}
            />
          )}
          {question.scope === "buttons" && (
            <Buttons
              items={question.items || defaultItems}
              onComplete={showNext}
              onChange={onChangeButton}
              screenIndex={id}
            />
          )}
        </div>
      )}
    </>
  );
}
